import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styles from '../ManagementPages.module.css';
import useAxios from '../../services/AxiosConfig';
import { showAlert } from '../../components/PerinHealthAlertSlice';
import PatientDetailDropdownCard from '../../components/PatientDetailDropdownCard';
import SecurityItemDetails from './SecurityItem';
import securityStyles from './Security.module.css';
import { formatMonthDay } from '../../utils/dateUtils';
import DateRangePicker from '../tasks/DateRangePicker';
import filterStyles from '../patient/Patient.module.css';
import { SpecialtySelectedIcon } from '../../components/icons/Icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Paginator } from 'primereact/paginator';
import paginatorStyles from '../../components/PerinHealthGrid.module.css';

import {
    startOfDay,
    endOfDay,
    isSameDay
} from "date-fns";

const PatientSecurity = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const axiosConfig = useSelector((state) => state.axiosConfig);
    const axios = useAxios(axiosConfig.envURL);
    const userDateFormat = useSelector((state) => state.userInfo.dateFormat);
    const security = useSelector((state) => state.securityManagement);

    const today = new Date();
    let weekStartInit = new Date(today);
    weekStartInit.setDate(today.getDate() - 7);
    const startDateObj = startOfDay(weekStartInit);

    const endDateObj = endOfDay(today);
    const [timePeriod, setTimePeriod] = useState('Week');
    const [startDate, setStartDate] = useState(startDateObj.toISOString());
    const [endDate, setEndDate] = useState(endDateObj.toISOString());
    const [searchText, setSearchText] = useState('');
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(20);
    const [activity, setActivity] = useState([]);

    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             const response = await axios.get(`logs/${security.id}?startDate=${startDate}&endDate=${endDate}`);
    //             console.log("response:  ", response)
    //         } catch (error) {
    //             console.error('Error fetching data:', error);
    //         }
    //     };

    //     fetchData();
    // }, [startDate, endDate]);


    const vitalFilters = [
        { label: "Week", value: "Week" },
        { label: "Month", value: "Month" },
        { label: "Custom", value: "Custom" },
    ];
    const [showDatePopover, setShowDatePopover] = useState(false);
    const customButtonRef = useRef(null);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };


    const handleCustomDateClick = (event) => {
        event.stopPropagation();
        setShowDatePopover(true);
    };

    const handleDateOrderChange = (value) => {

        const today = new Date();
        const dayStart = startOfDay(today);
        let startDateNew, endDateNew;

        switch (value) {
            case 'Week':
                endDateNew = endOfDay(today);
                let weekStart = new Date(today);
                weekStart.setDate(today.getDate() - 7);
                startDateNew = startOfDay(weekStart);
                break;
            case 'Month':
                endDateNew = endOfDay(today);
                let monthStart = new Date(today);
                monthStart.setDate(today.getDate() - 30);
                startDateNew = startOfDay(monthStart);
                break;
            default:
                startDateNew = dayStart;
                endDateNew = endOfDay(today);
                break;
        }

        startDateNew = startDateNew.toISOString();
        endDateNew = endDateNew.toISOString();
        setTimePeriod(value)
        setStartDate(startDateNew)
        setEndDate(endDateNew)
    };

    const handleDateRangeSave = (startDateNew, endDateNew) => {
        let start, end;
        if (startDateNew && endDateNew) {
            start = new Date(startDateNew);
            end = new Date(endDateNew);
        } else if (startDateNew) {
            start = new Date(startDateNew);
            end = new Date(startDateNew);
        } else if (endDateNew) {
            start = new Date(endDateNew);
            end = new Date(endDateNew);
        } else {
            return;
        }

        const formattedStartDate = start.toISOString();
        const formattedEndDate = end.toISOString();
        setTimePeriod('Custom')
        setStartDate(formattedStartDate)
        setEndDate(formattedEndDate)
    };


    return (
        <div className={styles.MainCard}>
            <div style={{ color: "4F4F4F", padding: "20px 0px 10px 20px" }} className="headline-6">{`View Patient Security Activity`}</div>
            <div style={{ display: "flex", flexDirection: "column", paddingLeft: "20px" }}>
                <span className="subtitle-2">Patient</span>
                <div className="body-2">{security.name}</div>
                <div className="body-2">{`Id: ${security.id}`}</div>
            </div>
            <div className={securityStyles.securityScrollContainer} >
                <div className={securityStyles.securityFilter}>
                    <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                        <div style={{ position: "absolute", paddingLeft: "10px" }}>
                            <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" size="xs" style={{ color: "D9D9D9" }} />
                        </div>
                        <input
                            id="searchText"
                            type="text"
                            value={searchText}
                            placeholder="Search Items"
                            style={{width:"200px"}}
                            className={styles.searchInput}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                    </div>
                    <div style={{flex:'1'}}></div>
                    <div className={securityStyles.formattedDateRange}>
                        {(() => {
                            if (startDate && endDate) {
                                const start = new Date(startDate);
                                const end = new Date(endDate);
                                
            
                                    const startTime = start.toLocaleString('en-US', { 
                                        hour: 'numeric', 
                                        minute: 'numeric' 
                                    });
                                    const endTime = end.toLocaleString('en-US', { 
                                        hour: 'numeric', 
                                        minute: 'numeric' 
                                    });
                    
                    
                                    if (formatMonthDay(start.toISOString(), userDateFormat) === formatMonthDay(end.toISOString(), userDateFormat) && startTime === '12:00 AM' && endTime === '11:59 PM') {
                                        return formatMonthDay(start.toISOString(), userDateFormat);
                                    } else if (timePeriod === "Week" || timePeriod === "Month") {
                                        return `${formatMonthDay(start.toISOString(), userDateFormat)} - ${formatMonthDay(end.toISOString(), userDateFormat)}`;
                                    } else {
                                        return `${formatMonthDay(start.toISOString(), userDateFormat)} ${startTime} - ${formatMonthDay(end.toISOString(), userDateFormat)} ${endTime}`;
                                    }

                            }
                            return '';
                        })()}
                    </div>
                    <div className={filterStyles.GraphPeriodButtons} style={{ marginRight: '10px' }}>
                        {vitalFilters.map((filter, index) => (
                            <div
                                key={index}
                                ref={filter.value === 'Custom' ? customButtonRef : null}
                                className={timePeriod === filter.value ? filterStyles.TimePeriodSelected : ''}
                                onClick={(event) => {
                                    if (filter.value === 'Custom') {
                                        handleCustomDateClick(event);
                                    } else {
                                        handleDateOrderChange(filter.value);
                                        setShowDatePopover(false);
                                    }
                                }}
                            >
                                {timePeriod === filter.value && <SpecialtySelectedIcon />}
                                {filter.label}
                            </div>
                        ))}
                    </div>
                </div>
                <div className={securityStyles.securityItemsList}>
                    {activity.map((activity, index) => {

                        return (
                            <div key={index}>
                                <PatientDetailDropdownCard
                                    title={activity.title}
                                    subtitle={activity.date}
                                    cardInfo={<SecurityItemDetails data={activity} />}
                                    width={'900px'}
                                />
                            </div>
                        )
                    })
                    }
                </div>
                <div style={{ display: "flex", alignItems: "center", paddingTop: "10px", justifyContent: "space-between", width: "740px" }}>
                <span
                    style={{
                        fontFamily: 'Roboto',
                        fontSize: '12px',
                        fontWeight: 500,
                        lineHeight: '16px',
                        textAlign: 'left',
                        color: '#25282B'
                    }}>
                    Total Number: {activity.length}
                </span>
                <Paginator
                    className={paginatorStyles.customPaginator}
                    first={first}
                    rows={rows}
                    totalRecords={activity.length}
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    onPageChange={onPageChange}
                    template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                />
                {/* </div> */}
            </div>
            </div>
            <DateRangePicker
                onSave={handleDateRangeSave}
                onClose={() => setShowDatePopover(false)}
                mode={"modal"}
                showModal={showDatePopover}
                timeSelect={true}
            />
            {/* <div className={styles.ButtonsFooterContainer}>
                <button 
                    className={styles.CreateButton}
                 
                >
                    {updatingRole ? "Update" : "Add"}
                </button>
                <button className={styles.CancelButton} onClick={() => navigate('/security-management')}>
                    Cancel
                </button>
            </div> */}
        </div>
    );
}

export default PatientSecurity;
